import {type ThemeIconKey} from 'platform/foundation';

import {RelatedCustomNoticesResourceId} from '@dms/api/core';
import i18n from '@dms/i18n';

import {TestIdProps} from 'shared/web';

import {CustomNoticesIndicator} from '../components/CustomNoticesIndicator/CustomNoticesIndicator';
import {CustomNoticesTab} from '../components/CustomNoticesTab/CustomNoticesTab';

interface BuildCustomNoticesSidebarActionParams extends TestIdProps {
  resourceId: RelatedCustomNoticesResourceId;
  recordId: string;
}

const CUSTOM_NOTICES_SIDEBAR_ACTION_ICON: ThemeIconKey = 'social/notifications';

export function buildCustomNoticesSidebarAction(params: BuildCustomNoticesSidebarActionParams) {
  return {
    id: 'custom-notices',
    label: i18n.t('general.customNotices.labels.title'),
    icon: CUSTOM_NOTICES_SIDEBAR_ACTION_ICON,
    indicator: (
      <CustomNoticesIndicator
        resourceId={params.resourceId}
        recordId={params.recordId}
        data-testid={params['data-testid']}
      />
    ),
    component: (
      <CustomNoticesTab
        resourceId={params.resourceId}
        recordId={params.recordId}
        data-testid={params['data-testid']}
      />
    ),
    'data-testid': params['data-testid'],
  };
}
